export default __webpack_public_path__ + "static/media/planet2.4fb5dbcb.png";